export const hari_libur = [
  {
    date: '2021-01-01',
    desc: 'Tahun Baru 2021 Masehi',
  },
  {
    date: '2021-02-12',
    desc: 'Tahun Baru Imlek',
  },
  {
    date: '2021-03-11',
    desc: "Isra Mi'raj Nabi Muhammad SAW",
  },
  {
    date: '2021-03-14',
    desc: 'Hari Suci Nyepi Tahun Baru Saka 1943',
  },
  {
    date: '2021-04-02',
    desc: 'Wafat Isa Al Masih',
  },
  {
    date: '2021-05-01',
    desc: 'Hari Buruh',
  },
  {
    date: '2021-05-13',
    desc: 'Kenaikan Isa Al Masih',
  },
  {
    date: '2021-05-13',
    desc: 'Hari Raya Idul Fitri 1442 H',
  },
  {
    date: '2021-05-14',
    desc: 'Hari Raya Idul Fitri 1442 H',
  },
  {
    date: '2021-05-30',
    desc: 'Hari raya Waisak',
  },
  {
    date: '2021-06-01',
    desc: 'Hari Lahir Pancasila',
  },
  {
    date: '2021-07-20',
    desc: 'Hari Raya Idul Adha 1442 H',
  },
  {
    date: '2021-08-10',
    desc: 'Tahun Baru Islam 1443 H',
  },
  {
    date: '2021-08-17',
    desc: 'Hari Kemerdekaan Republik Indonesia',
  },
  {
    date: '2021-10-19',
    desc: 'Maulid Nabi Muhammad SAW',
  },
  {
    date: '2021-12-24',
    desc: 'Cuti Bersama Natal',
  },
  {
    date: '2021-12-25',
    desc: 'Hari Raya Natal',
  },
];
